import {
	preventDoubleClick
} from '../global/_doubleClick';

export var addressDeleteConfirmation = function(params, returnHTML) {
      function myCallback() {
          
      }
      $('.addressDeleteForm').find('input[name="addressId"]').val(params.addressID);            
      
      $.ajax({
          url: "/static/html/modals/_delete-address-modal.html",
          success: function(html) {
              returnHTML(html, myCallback);
              return false;
          }
      });
  };
